showTracking = /hound=1/.test(document.cookie)

module.exports = (event) ->
  if showTracking
    output = "\ud83d\udc63 "
    styling = []
    for key, value of event
      # Still want to see value of 0 get tracked
      if value !in [undefined, null, '']
        output += "%c#{ key[0].toUpperCase() + key.substr(1) }:%c #{ value } "
        styling.push('color: #00f; font-weight: bold; background-color: #ddd; border-radius: 2px; padding: 0 2px;')
        styling.push('color: #444')
    console.log(output, styling...)


// WEBPACK FOOTER //
// ./app/scripts/debug/log-tracking.coffee